import React from "react";
import { motion } from "framer-motion";

const StatisticsSection = ({ stats }) => {
  if (!stats || stats.length === 0) return null;

  return (
    <section className="py-6 lg:py-8">
      <div className="max-w-[1700px] mx-auto px-6 sm:px-8 lg:px-10 xl:px-12">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 lg:gap-4">
          {stats.map((item, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{
                duration: 0.4,
                delay: index * 0.08,
              }}
              whileHover={{ y: -3 }}
              className="group flex min-h-[90px] sm:min-h-[100px] flex-col items-center justify-center rounded-xl border border-pink-100 bg-gradient-to-br from-orange-50/70 via-pink-50/70 to-purple-50/70 px-3 py-4 text-center shadow-sm transition-all duration-300 hover:border-[#EC4899]/40 hover:shadow-md"
            >
              {/* Number */}
              <h3 className="bg-gradient-to-r from-[#FF7A18] via-[#EC4899] to-[#8B5CF6] bg-clip-text text-2xl sm:text-3xl lg:text-[34px] font-extrabold leading-none text-transparent">
                {item.value}
              </h3>

              {/* Divider */}
              <div className="mt-2 h-[3px] w-8 rounded-full bg-gradient-to-r from-[#FF7A18] via-[#EC4899] to-[#8B5CF6] transition-all duration-300 group-hover:w-12" />

              {/* Label */}
              <p className="mt-2 text-xs sm:text-sm lg:text-[14px] font-medium leading-5 text-gray-700">
                {item.label}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatisticsSection;